import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { Scale, Size } from "./MyHelpers";
import { JackpotDisplayJubileeLink } from "./JackpotDisplayJubileeLink"
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { scale } from "svelte/transition";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { JackpotLevel } from "./api";
export class JackpotDisplayJubileeLink2S extends JackpotDisplayJubileeLink {
	public constructor(params: JackpotDisplayParams) {
		super(params)
		this.JP4JubileeLinkContainer.style.right = Scale.Xpx(-96);
		this.JP4JubileeLinkContainer.style.top = Scale.Ypx(0);

		this.JP3JubileeLinkContainer.style.width = Scale.Wpx(1314)
		this.JP3JubileeLinkContainer.style.right = Scale.Xpx(-37);
		this.JP3JubileeLinkContainer.style.top = Scale.Xpx(268);

		this.JP2JubileeLinkContainer.style.top = Scale.Xpx(564);
		this.JP2JubileeLinkContainer.style.width = Scale.Wpx(900)
		this.JP2JubileeLinkContainer.style.right = Scale.Xpx(51);
		
		this.JP1JubileeLinkContainer.style.top = Scale.Xpx(793);
		this.JP1JubileeLinkContainer.style.right = Scale.Xpx(0);
		this.JP1JubileeLinkContainer.style.width = Scale.Wpx(720);
		this.JP1JubileeLinkContainer.style.height = Scale.Hpx(270);

	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void> {
		if(loadingStage != LoadingStage.System) return ;
		await super.ResourcesLoaded(loadingStage,resourceManager);	
		
		this.JP3SpriteJackpot.ChangeSprite(resourceManager.Get<SpriteResource>(this.resid.Add("DiamondJubileeLink")).sprite);
		this.JP3SpriteJackpot.SetSize( new Size(Scale.W(1350), Scale.H(375)));
		this.JP3JubileeLinkContainer.appendChild(this.JP3SpriteJackpot.View());
		this.JP3SpriteJackpot.Scale(0.93);

		this.JP2SpriteJackpot.ChangeSprite(resourceManager.Get<SpriteResource>(this.resid.Add("EmeraldJubileeLink")).sprite);
		this.JP2SpriteJackpot.SetSize(new Size(Scale.W(910), Scale.H(270)));
		this.JP2SpriteJackpot.ScaleNonUniform(1.16, 1.16);		
		
		this.JP1SpriteJackpot.ChangeSprite(resourceManager.Get<SpriteResource>(this.resid.Add("SapphireJubileeLink")).sprite)
		this.JP1SpriteJackpot.SetSize(new Size(Scale.W(720), Scale.H(270)));
		this.JP1SpriteJackpot.Scale(1);
				
	}



	protected override PrepareJpContainer(resourceManager: ResourceManager) {
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/RubyJubileeLink", this.resid.Add("RubyJubileeLink"), true, this.logGroup.Add("RubyJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/DiamondJubileeLink", this.resid.Add("DiamondJubileeLink"), true, this.logGroup.Add("DiamondJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/EmeraldJubileeLink_2Screen", this.resid.Add("EmeraldJubileeLink"), true, this.logGroup.Add("EmeraldJubileeLink"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotDisplayJubileeLink/Sprites/SapphireJubileeLink_2Screen", this.resid.Add("SapphireJubileeLink"), true, this.logGroup.Add("SapphireJubileeLink"), true));

	}

	protected override CreateJPText()
	{
		let jp4TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1500),
			height: Scale.H(175),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
		}
		// //this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(338);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(114); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.JP4JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		// //JackpotFont 3

		let jp3TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(842),
			height: Scale.H(120),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
		}
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(345);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(130);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.JP3JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		//JackpotFont 2

		let jp2TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(530),
			height: Scale.H(100),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
		}
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(270);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(100);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.JP2JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());

		//JackpotFont 1
		let jp1TextParams: JackPotTextParams = {

			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(400),
			height: Scale.H(80),
			color:  "black",
			color2: "black",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
		}
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(243);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(97);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.JP1JubileeLinkContainer.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());


	}


}
